import { LOGO } from '../constants/imageTemplates';
import config from '../config';
import { createAuth } from '@justgiving/auth';
import { getLoginPageUrlParameters } from './getLoginPageUrlParameters';
import { BBAuth } from '@blackbaud-internal/auth-client';
import { RedirectToLoginError } from '../components/ErrorBoundary/errors';
import type { BBAuthGetTokenArgs } from '@blackbaud-internal/auth-client/src/auth/auth-get-token-args';

const { authCookieName, activeGroupCookieName, refreshAccessTokenUrl } = config;

export const auth = createAuth({
  documentOrReq: document,
  authCookieName,
  activeGroupCookieName,
  refreshAccessTokenUrl,
});

export const getCharityId = () => {
  const permission = auth.getActivePermission('charity');

  return permission?.groupTypeExternalId
    ? parseInt(permission.groupTypeExternalId, 10)
    : undefined;
};

export const isCampaignAdmin = () => {
  return (
    auth.hasGroupRole('charity', 'admin') ||
    auth.hasGroupRole('charity', 'fundraising')
  );
};

export const getUserFullName = () => {
  const token = auth.getAccessToken();
  return token?.givenName || token?.familyName
    ? `${token.givenName} ${token?.familyName}`
    : null;
};

type GetLoginUrlParams = {
  campaignId?: string;
  campaignTitle?: string;
  causeLogo?: string;
  charityName?: string;
  eventName?: string;
  title?: string;
  logo?: string;
  returnUrl?: string;
};

export function getLoginUrl(params?: GetLoginUrlParams) {
  const ssoUrl = new URL(config.consumerSSOUrl);

  const { returnUrl, ...encodedParams } = params ?? {};

  ssoUrl.searchParams.set('returnUrl', returnUrl ?? window.location.href);
  ssoUrl.searchParams.set('Promo', 'true');
  ssoUrl.searchParams.set('flowtype', 'page_creation');

  if (encodedParams && Object.keys(encodedParams).length > 0) {
    ssoUrl.searchParams.set(
      'EncodedOptions',
      getLoginPageUrlParameters({
        campaignId: encodedParams.campaignId,
        campaignTitle: encodedParams.campaignTitle,
        causeLogo: `${encodedParams.causeLogo}?template=${LOGO}`,
        charityName: encodedParams.charityName,
        eventName: encodedParams.eventName,
        title: encodedParams.title,
      }) ?? ''
    );
  }

  return ssoUrl.toString();
}

export async function getBBToken(bbAuthGetTokenArgs?: BBAuthGetTokenArgs) {

  try {
    return await BBAuth.getToken(bbAuthGetTokenArgs);
  } catch {
    throw new RedirectToLoginError();
  }
}
